module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        staticLookupName: 'absenceController',
        // showColorBar: true,
        tabConfigNavKey: 'absence',
        showEditByMySelf: true,
    },
}